import React, {  PureComponent  } from 'react';
import { Collapse  } from 'antd';
import { generalData, invoicesTotal } from './graphicsData';
import EmptyContent from './EmptyContent';
import CustomPieChart from '../_Generic/PieChart/index';
import CustomLineChart from '../_Generic/LineChart/index';
const { Panel } = Collapse;

class General extends PureComponent {

	render() {
		if(!this.props.data)
			return <EmptyContent />;
		
		const { data, dataCfdiType, numberOfCfdisCanceled, numberOfCfdisDuplicated } = this.props.data;		
		return (
			<Collapse accordion defaultActiveKey={['1']}>
                <Panel header="CFDIS obtenidos" key="1">
					<CustomPieChart data={generalData(dataCfdiType)} width={300} height={250} colorFill="#8884d8" />
                </Panel>
                <Panel header="Facturas canceladas y duplicadas" key="2">
                    <div className="box">
						<span className="label">Canceladas</span>
						<span className="number-text">{numberOfCfdisCanceled}</span>
					</div>
					<div className="box">
						<span className="label">Duplicadas</span>
						<span className="number-text">{numberOfCfdisDuplicated}</span>
					</div>
                </Panel>
                <Panel header="Cantidad de facturas Timbradas" key="3">			
					{
						data && 		
						<CustomLineChart data={invoicesTotal(data)} width={300} height={250} stroke="#65DD33" dataKey="Cantidad"/>
					}
                </Panel>
				<Panel header="Total de facturas $" key="4">
					{
						data && 
						<CustomLineChart data={invoicesTotal(data)} width={300} height={250} stroke="#65DD33" />
					}
                </Panel>
            </Collapse>
		)
	}
}


export default General;